import { type FC, type ReactNode } from 'react'

import { type PimABDASubstanceV1 } from '@redteclab/api/clients/bully'

interface ProductDescriptionIngredientsSectionProps {
  header: ReactNode
  substances: PimABDASubstanceV1[]
}

export const ProductDescriptionIngredientsSection: FC<
  ProductDescriptionIngredientsSectionProps
> = ({ header, substances }) => {
  return (
    <section className="text-dark-primary-max">
      <h3 className="text-s font-medium">{header}</h3>
      <ul className="mb-3.5 list-disc pl-5 text-s">
        {substances.map(
          ({ agent_id: key, description, quantity, unit }, index) => (
            // eslint-disable-next-line react/no-array-index-key -- unfortunately agent_id is not unique
            <li key={`${key}-${index}`}>
              {[quantity, unit, description].filter(Boolean).join(' ')}
            </li>
          ),
        )}
      </ul>
    </section>
  )
}
